import { render } from "./ItemInfo.vue?vue&type=template&id=c3fbf622&scoped=true&ts=true"
import script from "./ItemInfo.vue?vue&type=script&lang=ts"
export * from "./ItemInfo.vue?vue&type=script&lang=ts"

import "./ItemInfo.vue?vue&type=style&index=0&id=c3fbf622&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fbf622"]])

export default __exports__